// extracted by mini-css-extract-plugin
module.exports = {"container":"changelog_container__YGwGk","title":"changelog_title__QDG2e","backIconContainer":"changelog_backIconContainer__g7B_m"};